import { z } from 'zod'

import { TranslationKeys } from '@/@types/keys/translation'

export const searchSchema = z.object({
  search: z.string(),
})
export type SearchSchema = z.infer<typeof searchSchema>

export type SearchProps = React.InputHTMLAttributes<HTMLInputElement> & {
  formClassName?: string
  inputClassName?: string
  placeholder?: TranslationKeys
  searchValue?: string
  onClear?: () => void
}
